import { Auth } from 'pages/Auth';
import { MainRoutes } from 'pages';

export const getRoutes = isAuthenticated => {
    if (isAuthenticated) {
        return <MainRoutes/>
    }
    return <Auth/>
};
